<template>
    <div class="person">
        <div class="table">
            <div class="handle">
                <el-button type="" icon="el-icon-edit" size="small" @click="editComment()">确认编辑</el-button>
            </div>
            <el-input
            type="textarea"
            :rows="20"
            placeholder="请输入内容"
            v-model="content">
            </el-input>
        
        </div>

    </div>
</template>
<script>
import api from '../../../api/main'
import queryCondition from '../../../components/queryCondition'
import forms from '../../../components/form'
import {wtlxList,isNewList} from '../../../assets/selectList/index'
import {parseTimeS} from '../../../utils/index'
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'

export default {
    name: 'person',
    components:{
       
    },
    watch: {
    },
    data () {
        return {
            content:'',
        }
    },
    created(){
    },
    mounted(){
        setTimeout(() => {
            this.loadingData();
        }, 300)
    },
    methods:{
       
        // 加载table数据
        async loadingData() {
            let res  = await api.memesList({});
            console.log('res');
            console.log('res');
            console.log('res');
            console.log('res');
            console.log(res);
            this.content = res.data.data[0].content;
        },
        
        
        // 编辑方法
        async editComment(){
            let res = await api.memesReplace(
                [{content:this.content}]
            );
            if(res.data.code == '200'){
                this.$message({
                    type: 'success',
                    message: '操作成功'
                });  
            }
        },
        
    }
    
}
</script>

<style lang="scss" scoped>
    .condition{
        background-color: #ffffff;
        display: flex;
        align-items: center;
        border-radius: 5px;
        padding: 15px;
        font-size: 14px;
        
    }
    .table{
        margin-top: 10px;
        background-color: #ffffff;
        padding: 15px;
        .handle{
            width: 100%;
            display: flex;
            justify-content: space-between;
            padding-bottom: 15px;
            align-items: center;
            font-size: 20px;
        }
        .page{
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 16px;
            .el-pagination{
                margin-left: -10px;
            }
        }
    }
    .dialog{
        display: flex;
        flex-direction: column;
        padding-top: 16px;
        height: 100%;
        .item{
            font-size: 14px;
            padding:8px 15px;
            display: flex;
            align-items: center;
            .label{
                width: 150px;
                margin-bottom: 5px;
            }
            .value{
                display: flex;
                width: 400px;
            }
            .input{
                width: 215px;
                display: flex;
            }
        }
        .picList{
            display: flex;
            flex-wrap: wrap;
            margin:0 10px;
            .pic{
                position: relative;
                margin: 5px;
                width: 100px;
                height: 100px;
                .pic-edit{
                    position: absolute;
                    z-index: 10;
                    top: -10px;
                    right: -10px;
                    width: 22px;
                    height: 22px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;
                    i{
                        color: #ffffff;
                    }
                    .error{
                        color: #f56c6c;
                    }
                    .success{
                        color: #a9ffa9;
                    }
                }
            }
        }
        .btns{
            background-color: #ffffff;
            width: 100%;
            bottom: 0;
            display:flex;
            justify-content: center;
            .el-button{
                margin-right: 10px;
            }
        }
    }
    :deep(.el-input.is-disabled .el-input__inner){
        color: #222222;
    }
    :deep(.el-textarea.is-disabled .el-textarea__inner){
        color: #222222;
    }
    .cursor{
        cursor: pointer;
    }
</style>
